import { EntityType } from "@mapmycustomers/shared/enum";
import { Activity } from "@mapmycustomers/shared/types/entity";
import { RouteStopBulkItem } from "@mapmycustomers/shared/types/entity/Route";

import durationSecondsFromActivity from "@app/scene/routes/component/RouteDetails/utils/durationSecondsFromActivity";

import { EditorRouteStop } from "../../types/RouteStop";
import { isCompanyStop, isManualStop, isPersonStop } from "../../utils/stopPredicates";

import resolveActivityStopEntity from "./resolveActivityStopEntity";

const getAppendStopsOperations = (
  activities: ReadonlyArray<Activity>,
  stops: ReadonlyArray<EditorRouteStop>
): RouteStopBulkItem[] => {
  const operationByKey = new Map<string, RouteStopBulkItem>();

  activities.forEach((activity) => {
    const ref = resolveActivityStopEntity(activity);
    if (!ref) {
      return;
    }
    const key = `${ref.entityType}:${ref.id}`;
    if (operationByKey.has(key)) {
      return;
    }
    const allottedTime = durationSecondsFromActivity(activity);
    operationByKey.set(
      key,
      ref.entityType === EntityType.COMPANY
        ? { _action_: "c", accountId: ref.id, allottedTime, syncedActivityId: activity.id }
        : { _action_: "c", allottedTime, contactId: ref.id, syncedActivityId: activity.id }
    );
  });

  stops.forEach((stop) => {
    let key: string | undefined;
    let operation: RouteStopBulkItem | undefined;
    if (isCompanyStop(stop)) {
      key = `${EntityType.COMPANY}:${stop.accountId}`;
      operation = {
        _action_: "c",
        accountId: stop.accountId,
        allottedTime: stop.allottedTime,
        scheduledTime: stop.scheduledTime ?? null,
      };
    } else if (isPersonStop(stop)) {
      key = `${EntityType.PERSON}:${stop.contactId}`;
      operation = {
        _action_: "c",
        allottedTime: stop.allottedTime,
        contactId: stop.contactId,
        scheduledTime: stop.scheduledTime ?? null,
      };
    } else if (isManualStop(stop)) {
      key = `manual:${stop.id}`;
      operation = {
        _action_: "c",
        allottedTime: stop.allottedTime,
        manualAddress: stop.manualAddress,
        manualGeoPoint: stop.manualGeoPoint,
        manualName: stop.manualName,
        scheduledTime: stop.scheduledTime ?? null,
      };
    }
    if (!key || !operation || operationByKey.has(key)) {
      return;
    }
    operationByKey.set(key, operation);
  });

  return Array.from(operationByKey.values());
};

export default getAppendStopsOperations;
